import {TimeTransactionAction} from '@/store/time-transaction/time-transaction.actions';
import {TimeTransactionMutations} from '@/store/time-transaction/time-transaction.mutations';
import {
  EntityTimeTransactionService,
  TimeTransactionInitState
} from '@/store/time-transaction/time-transaction.types';

const namespaced = true;

export const timeTransactionInitState: TimeTransactionInitState = {
  timeTransactions: [{}] as EntityTimeTransactionService[]
};

export const timeTransactionState = {
  namespaced,
  state: timeTransactionInitState,
  actions: TimeTransactionAction,
  mutations: TimeTransactionMutations,
  // getters
};
